import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LockedFunds, Wallet } from "../../repositories/WalletRepository";
import { WalletType } from "../../models/Transactions";

export enum CurrencyType {
    SATS = 'SATS',
    FIAT = 'FIAT'
}

export enum WalletStatus {
    ACTIVE = 'active',
    LOADING = 'loading',
    SYNCING = 'syncing',
    ERROR = 'error',
    OTHER_WALLET_ACTIVE = 'other-wallet-active',
}

export interface WalletInfos {
    status: WalletStatus;
    balance: number | null;
    walletType: WalletType | null;
    lnurl: string;
    staticAddress: string;
    lockedFunds?: LockedFunds;
    nwcConnectionString?: string;
    currencyType: CurrencyType;
    shouldShowSeed: boolean;
    identityPubkey?: string;
    stats?: {
        sent: number;
        received: number;
    };
}

const initialState: WalletInfos = {
    status: WalletStatus.LOADING,
    balance: null,
    walletType: null,
    lnurl: '',
    staticAddress: '',
    nwcConnectionString: undefined,
    currencyType: CurrencyType.SATS,
    shouldShowSeed: false,
    identityPubkey: undefined,
    stats: undefined,
}

const walletSlice = createSlice({
    name: 'wallet',
    initialState,
    reducers: {
        setStatus: (state, action: PayloadAction<WalletStatus>) => {
            state.status = action.payload;
        },
        setCurrencyType: (state, action: PayloadAction<CurrencyType>) => {
            state.currencyType = action.payload;
        },
        setShouldShowSeed: (state, action: PayloadAction<boolean>) => {
            state.shouldShowSeed = action.payload;
        },
        setLnurl: (state, action: PayloadAction<string>) => {
            state.lnurl = action.payload;
        },
        setStaticAddress: (state, action: PayloadAction<string>) => {
            state.staticAddress = action.payload;
        },
        setInfos: (state, action: PayloadAction<Wallet>) => {
            state.lnurl = action.payload.lnurl;
            state.balance = action.payload.balance;
            if(action.payload.lockedFunds)
                state.lockedFunds = action.payload.lockedFunds;
            if(action.payload.nwcConnectionString)
                state.nwcConnectionString = action.payload.nwcConnectionString;
            if(action.payload.shouldShowSeed)
                state.shouldShowSeed = action.payload.shouldShowSeed;
            if(action.payload.staticAddress)
                state.staticAddress = action.payload.staticAddress;
            if(action.payload.identityPubkey)
                state.identityPubkey = action.payload.identityPubkey;
        },
        setNWCConnectionString: (state, action: PayloadAction<string>) => {
            state.nwcConnectionString = action.payload;
        },
        setWalletType: (state, action: PayloadAction<WalletType>) => {
            state.walletType = action.payload;
        },
        setBalance: (state, action: PayloadAction<number>) => {
            state.balance = action.payload;
        },
        setStats: (state, action: PayloadAction<{ sent: number; received: number }>) => {
            state.stats = action.payload;
        },
    }
});

export const { setInfos, setLnurl, setStaticAddress, setNWCConnectionString, setBalance, setWalletType, setCurrencyType, setStatus, setShouldShowSeed, setStats } = walletSlice.actions;
export default walletSlice.reducer; 